export const getRolePlayName = (isFirst: boolean): string => {
  return isFirst ? 'ファーストロールプレイ' : 'セカンドロールプレイ';
};
